import { Type } from "@warp-drive/core/types/symbols";
import type { Derivation } from "@warp-drive/core/types/schema/concepts";

export const derivation = <R, T = unknown>(type: string, fn: (record: R) => T): Derivation<R, T> =>
  Object.assign(fn, { [Type]: type });
